import { jsx as _jsx } from "react/jsx-runtime";
import { Vibrate, VibrateOff } from 'lucide-react';
import { useHapticSettings, haptic } from '@/lib/haptic';
import { cn } from '@/lib/utils';
/**
 * Toggle haptic on/off. Affiché uniquement si l'appareil supporte la
 * Web Vibration API (caché côté desktop pour ne pas polluer l'UI).
 *
 * Persiste via localStorage (cf src/lib/haptic.ts). Donne un petit
 * pulse de feedback à l'activation pour confirmer que ça marche.
 */
export function HapticToggle() {
    const { enabled, supported, setEnabled } = useHapticSettings();
    if (!supported)
        return null;
    return (_jsx("button", { type: "button", "aria-label": enabled ? 'Couper la vibration' : 'Activer la vibration', title: enabled ? 'Couper la vibration' : 'Activer la vibration', onClick: () => {
            const next = !enabled;
            setEnabled(next);
            if (next)
                haptic.success(); // confirme que ça marche
        }, className: cn('grid h-10 w-10 place-items-center rounded-xl transition-colors', enabled
            ? 'text-ink-300 hover:bg-ink-900/60 hover:text-ink-100'
            : 'text-ink-500 hover:bg-ink-900/60 hover:text-ink-300'), children: enabled ? _jsx(Vibrate, { className: "h-4 w-4" }) : _jsx(VibrateOff, { className: "h-4 w-4" }) }));
}
